module.exports = __webpack_public_path__ + "img/logo_p.d8ab5ac7.png";